import React from "react";

type Props = {
  emailAddress: string;
  orderId: string;
  visible?: boolean;
  children?: React.ReactNode;
  total?: number | string;
};

const TourOrderDetails = ({ emailAddress, orderId, visible = true, total }: Props) => {
  if (!visible) return null;
  const parsedTotal = parseInt(`${total || 0}`);
  const orderTotal = parsedTotal ? `$${parsedTotal}` : "your donation";

  return (
    <>
      {/* TODO: Update the styles */}
      <div className="order-confirmation__order-info">
        <strong className="order-confirmation__order-info-title">
          {orderTotal} Donation (#{orderId})
        </strong>
        <p>
          A confirmation email will be sent to <strong>{emailAddress}</strong>
        </p>
      </div>
    </>
  );
};

export default TourOrderDetails;
